import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import Referenzen from './referenzen';

function SysMobil () {

    return (
        <div className="mainContentWrapper">

            <div className="contentContainer">
                
                <div className="contentColumns">
                    <div className="landingleft slideInLeft marginHundred">
                        
                       <div className='contentCentered'>
                            <p>Das Verkaufsgespräch steht im Mittelpunkt.</p>
                            <br/>
                            <p>Mit sys.mobil hat die Vertreterin und der Vertreter alle relevanten Daten direkt im Zugriff: Verlagsübergreifende Bestellformulare für alle Titel, Vorbestellungen, Bestsellerlisten, 
                                Rabatte und Konditionen, intelligente Suche über ISBN, Stichwort oder Barcode und vieles mehr.</p>    
                                
                                <p> 
                                Das Gespräch mit der Buchhändlerin und dem Buchhändler konzentriert sich auf Bücher und Inhalte, 
                                sys.mobil macht die Vertreterin und den Vertreter effektiver und erfolgreicher. Und für den Verlag 
                                bedeutet das: mehr Umsatz, bessere Präsenz im Buchhandel und deutlich geringere Kosten.
                                </p>
                        </div> 
                        
                    </div>
                    <div className="landingright slideInRight marginHundred">
                        <img src={'/assets/img/wuerfel-web.png'}/>
                    </div>

                </div>

                <div className="sloganContainer">
                    <div className="sloganContainerRowR">
                        <div className="sloganRed slideInRight">
                            Eine für alle.
                        </div>
                    </div>
                    <div className="sloganContainerRowG">
                        <div className="sloganGrey slideInLeft">
                            Die Software für Verlagsvertretungen
                            <br/>
                            Auslieferungsunabhängig und verlagsübergreifend
                        </div>
                    </div>
                </div>

                <div className="contentColumns">

                    <div className="landingleft slideInLeft">
                        
                        <p>Die Vorteile auf einen Blick</p>
                        <br/>
                        <ul>
                            <li>Alle verkaufsrelevanten Daten – Umsätze, Vormerkungen, Bestellungen und Konditionen – sofort im Zugriff</li>   
                            <li>Für eine konkurrenzlos schnelle Auftragserfassung sorgen verlags- und auslieferungsübergreifende Bestellmasken</li> 
                            <li>Gezielte Bestellaufnahme durch verlags-, vertreter- oder kundenspezifische Auftragsvorlagen und Bestsellerlisten</li> 
                            <li>Komfortable Titelsuche über ISBN/EAN, Stichwort oder über Barcode</li> 
                            <li>Unkomplizierte Erfassung von Lese- und anderen Freiexemplaren</li>  
                            <li>Automatische Rabattermittlung</li>  
                        </ul>   

                        
                    </div>
                    <div className="landingright slideInRight">
                        <p>Weitere Features</p>
                        <br/>
                        <ul>
                            <li>Werbe- und Rabattaktionen der Verlage können direkt eingespielt werden</li>
                            <li>Umfangreiche Verkaufsstatistiken, einfacher Datenexport in Excel oder Open-Office</li>
                            <li>Leicht editierbare Besuchsberichte</li>
                            <li>Lageraufnahme über Barcode</li>
                            <li>Verlagsportfolio, Kunden-, Titel- und Verkaufsdaten werden automatisch eingespeist</li>
                            <li>Tägliche Bereitstellung des aktuellen Datenbestandes</li>
                        </ul>    
                    </div>

                </div>

                <div className="sloganContainer">
                    <div className="sloganContainerRowW">
                        <div className="sloganWhite slideInLeft">
                            <Link to="/tutorials">sys.mobil - Tutorials</Link>
                        </div>
                    </div>
                   
                </div>


            </div>

           

        </div>
    )

}

export default SysMobil;